import { render, staticRenderFns } from "./DefaultPasswordRecoveryComplete.vue?vue&type=template&id=1e56dce4&lang=pug&"
import script from "./DefaultPasswordRecoveryComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultPasswordRecoveryComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports